export default __webpack_public_path__ + "static/media/Back_end_-_adamr.space___Codecademy.1ad63058.pdf";